import { ReactComponent as VerticalDrag } from "@svgr/webpack?-svgo,+titleProp,+ref!./VerticalDrag.svg";
import { ReactComponent as StarHalf } from "@svgr/webpack?-svgo,+titleProp,+ref!./StarHalf.svg";
import { ReactComponent as Up } from "@svgr/webpack?-svgo,+titleProp,+ref!./Up.svg";
import { ReactComponent as StarBlank } from "@svgr/webpack?-svgo,+titleProp,+ref!./StarBlank.svg";
import { ReactComponent as Star } from "@svgr/webpack?-svgo,+titleProp,+ref!./Star.svg";
import { ReactComponent as ProgressInactive } from "@svgr/webpack?-svgo,+titleProp,+ref!./ProgressInactive.svg";
import { ReactComponent as ProgressActive } from "@svgr/webpack?-svgo,+titleProp,+ref!./ProgressActive.svg";
import { ReactComponent as Open } from "@svgr/webpack?-svgo,+titleProp,+ref!./Open.svg";
import { ReactComponent as Lock } from "@svgr/webpack?-svgo,+titleProp,+ref!./Lock.svg";
import { ReactComponent as Information } from "@svgr/webpack?-svgo,+titleProp,+ref!./Information.svg";
import { ReactComponent as Dropdown } from "@svgr/webpack?-svgo,+titleProp,+ref!./Dropdown.svg";
import { ReactComponent as Down } from "@svgr/webpack?-svgo,+titleProp,+ref!./Down.svg";
import { ReactComponent as CloudSuccess } from "@svgr/webpack?-svgo,+titleProp,+ref!./CloudSuccess.svg";
import { ReactComponent as CloudFailure } from "@svgr/webpack?-svgo,+titleProp,+ref!./CloudFailure.svg";
import { ReactComponent as Closed } from "@svgr/webpack?-svgo,+titleProp,+ref!./Closed.svg";
import { ReactComponent as Check } from "@svgr/webpack?-svgo,+titleProp,+ref!./Check.svg";
import { ReactComponent as Questions } from "@svgr/webpack?-svgo,+titleProp,+ref!./Questions.svg";
import { ReactComponent as CreditCardDefault } from "@svgr/webpack?-svgo,+titleProp,+ref!./CreditCardDefault.svg";
import { ReactComponent as CreditCardInvalid } from "@svgr/webpack?-svgo,+titleProp,+ref!./CreditCardInvalid.svg";
import { ReactComponent as Drag } from "@svgr/webpack?-svgo,+titleProp,+ref!./Drag.svg";
export const IndicatorIcons = {
  VerticalDrag,
  StarHalf,
  Up,
  StarBlank,
  Star,
  ProgressInactive,
  ProgressActive,
  Open,
  Lock,
  Information,
  Dropdown,
  Down,
  CloudSuccess,
  CloudFailure,
  Closed,
  Check,
  Questions,
  CreditCardDefault,
  CreditCardInvalid,
  Drag
};
export const IndicatorIconNames = ["VerticalDrag", "StarHalf", "Up", "StarBlank", "Star", "ProgressInactive", "ProgressActive", "Open", "Lock", "Information", "Dropdown", "Down", "CloudSuccess", "CloudFailure", "Closed", "Check", "Questions", "CreditCardDefault", "CreditCardInvalid", "Drag"];